import React from "react";

import java from "../assets/java.png"
import python from "../assets/python.png"
import c from "../assets/c.png"
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import unity from "../assets/unity.png"
import reactImage from "../assets/react.png";
//import blender from "../assets/blender.png"
//import sql from "../assets/sql.png"
//import android from "../assets/android.png"
//import github from "../assets/github.png";


const Experience = () => {
  const techs = [
    {
      id: 1,
      src: java,
      title: "Java",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: python,
      title: "Python",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: c,
      title: "C & C++",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: html,
      title: "HTML",
      style: "shadow-blue-600",
    },
    {
      id: 5,
      src: css,
      title: "CSS",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: javascript,
      title: "JavaScript",
      style: "shadow-white",
    },
    {
      id: 7,
      src: unity,
      title: "Unity",
      style: "shadow-pink-400",
    },
    {
      id: 8,
      src: reactImage,
      title: "React",
      style: "shadow-gray-400",
    },

    /*
    {
      id: 9,
      src: blender,
      title: "Blender",
      style: "shadow-gray-400",
    },
    {
      id: 10,
      src: sql,
      title: "SQL",
      style: "shadow-gray-400",
    },
    {
      id: 11,
      src: android,
      title: "Android",
      style: "shadow-gray-400",
    },
    {
      id: 12,
      src: github,
      title: "Github",
      style: "shadow-gray-400",
    },
    */
  ];

  return (
    
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-screen"
    >
      < div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white">
        <div>
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline">
            Experience
          </p>
          <p className="py-6">These are the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3 gap-5 text-center py-8 px-12 sm:px-0">
          {techs.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
        </div>
        
      </div>
      
    </div>
  );
};

export default Experience;
